import React from 'react';
import classnames from 'classnames';
import s from './BackgroundImage.scss';

export interface Props {
  src: string;
  blur?: boolean;
  subtleBlur?: boolean;
  fade?: 'small' | 'full' | 'full-strong' | false;
  className?: string;
  imageClassName?: string;
}

export const BackgroundImage: React.FC<Props> = ({
  src,
  blur,
  subtleBlur,
  fade,
  className,
  imageClassName,
}) => {
  return (
    <div
      className={classnames(
        s['root'],
        blur && s['blur'],
        subtleBlur && s['subtle-blur'],
        fade && s['fade'],
        fade && s[`fade-${fade}`],
        className
      )}
    >
      <div
        className={classnames(s['image'], imageClassName)}
        style={{
          backgroundImage: `url('${src}')`,
        }}
      />
    </div>
  );
};

BackgroundImage.displayName = 'BackgroundImage';

export default BackgroundImage;
